<template>
  <div id="app" :class="[currentLocale, { iphone: isIphone }, Browser]">
    <Loading id="appLoading" :is-show="$store.state.isAppLoad" />
    <Language
      id="appLanguage"
      :is-show="$store.state.isLanguage"
      :ispositionbottom="$store.state.ispositionbottom"
    />
    <router-view />
    <FGFmodal v-if="$store.state.isFGF" :is-show="$store.state.isFGF" />
    <FooterMenu
      v-if="$store.state.isFooterMenu"
      id="appFooterMenu"
      :is-show="$store.state.isFooterMenu"
    />
  </div>
</template>

<script>
import Util from '@/helper/Utility.js'
import FGFmodal from '@/components/Layout/FGFmodal'
import Locale from '@/helper/Locale.js'

export default {
  components: { FGFmodal },
  data: function () {
    return {
      isIphone: Util.getiPhone(),
      Browser: Util.getBrowserName(),
      currentLocale: Locale.getLocale(),
    }
  },
}
</script>
<style lang="scss">
@import '@/style/main.scss';
#app {
  overflow: hidden;
}

//แนวตั้ง
@media only screen and (min-device-width: 600px) and (orientation: portrait) {
  #app {
    height: 100%;
    overflow-y: auto;
  }
}

//แนวนอน
@media only screen and (min-device-width: 1024px) and (min-device-height: 768px) and (orientation: landscape) {
  #app {
    height: 100%;
    overflow-y: auto;
  }
}
</style>
